module.exports = {
  localeName: 'de-AT',
  momentFormat: 'DD.MM.YYYY',
  qrCodeUrl: 'https://www.inmoment.com/websurvey/2/begin?gateway=NikeNAQRCode&base32=surveyCode&PrintEreceipt=1',
  taxId: 'Shop-MwSt. ',
};
